import { createContext, useContext } from 'react';
import { PapsContext } from './PapsContext';
import { useRegDemo } from './useHelpers/useRegDemo';

/** AppContext */
export const RegDataContext = createContext();

/** Global OtherDatas for the Event */
const RegDataProvider = (props) => {

  // papsContext
  const papsContext = useContext(PapsContext)
  const { paps_state } = papsContext ?? {}
  const { pathViews } = paps_state ?? {}
  const { events: settingsDocName } = pathViews ?? {}

  const isDemo = paps_state?.queryValues?.regdemo

  const regData_state = useRegDemo({ isDemo, settingsDocName, showToken: false })

  const providerContext = () => <RegDataContext.Provider value={{ regData_state }} >
    {props.children}
  </RegDataContext.Provider>

  return providerContext()
}

export default RegDataProvider